import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=c2ca6b3a&"
import script from "./Filter.vue?vue&type=script&lang=ts&"
export * from "./Filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/home/vsts/work/1/a/NuxtApp/components/base/Icon.vue').default,BaseCheckbox: require('/home/vsts/work/1/a/NuxtApp/components/base/Checkbox.vue').default,BaseCollapseOptions: require('/home/vsts/work/1/a/NuxtApp/components/base/CollapseOptions.vue').default,BaseToggle: require('/home/vsts/work/1/a/NuxtApp/components/base/Toggle.vue').default,ProductPriceSlider: require('/home/vsts/work/1/a/NuxtApp/components/product/PriceSlider.vue').default,BaseOverlay: require('/home/vsts/work/1/a/NuxtApp/components/base/Overlay.vue').default})
